import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space } from 'antd';
import { MessageStatusEnum } from 'api/MessagesApi';
import { useMessageService } from 'components/Message/useMessageService';
import { useCompanyContext } from 'contexts/CompanyContext';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectAuthUser } from 'store/authSlice';
import { getAccessLevelByMessageType, hasOrganizationSponsoredUnlimitedAccess, logging, userHasAccess } from 'utils/utils';

type AllProps = {
  onNext: (shouldExit?: boolean) => void;
  onBack: () => void;
  initTitle?: string;
};

function StepTitle({ onNext, onBack, initTitle }: AllProps) {
  const navigate = useNavigate();
  const { companyConfig } = useCompanyContext();
  const { message, updateIsLoading, updateMessageName, publishMessage } = useMessageService();
  const user = useSelector(selectAuthUser);
  const hasOrgSponsoredAccess = hasOrganizationSponsoredUnlimitedAccess(user);
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      const fields = form.getFieldsValue();

      await updateMessageName({ name: fields.name });

      onNext(true);
    } catch (e) {
      logging(e);
    }
  };

  const handleGetCredits = () => {
    navigate('/pricing', { state: { messageId: message!.id } });
  };

  const handlePublish = async () => {
    try {
      await form.validateFields();
      const fields = form.getFieldsValue();

      await publishMessage(fields.name);

      onNext();
    } catch (e) {
      logging(e);
    }
  };

  useEffect(() => {
    form.setFieldValue('name', message?.name || '');
  }, [form, message]);

  if (!message) return null;

  return (
    <div className="step-title create-message-component-full-height">
      <Form
        layout="vertical"
        autoComplete="off"
        requiredMark="optional"
        form={form}
        initialValues={{ name: message.name || initTitle || '' }}
        onFinish={handleSubmit}
      >
        <div className="create-message-component-title">Give your message a name.</div>

        <Form.Item name="name" label="Message Title" rules={[{ required: true }]}>
          <Input placeholder="Message Name" autoFocus />
        </Form.Item>
      </Form>

      <Row className="create-message-component-footer">
        <Col xs={6}>
          <Button onClick={onBack} type="link">
            <ArrowLeftOutlined /> Back
          </Button>
        </Col>
        <Col xs={18} className="text-right">
          <Space>
            {message.status === MessageStatusEnum.Draft && <Button onClick={() => handleSubmit()}>Save & Exit</Button>}

            {companyConfig.isEnterprise || hasOrgSponsoredAccess || userHasAccess(user, getAccessLevelByMessageType(message.type)) ? (
              <>
                {message.status === MessageStatusEnum.Draft ? (
                  <Button
                    type="primary"
                    onClick={handlePublish}
                    loading={updateIsLoading}
                    disabled={!(message?.contacts || []).length}
                  >
                    Publish
                  </Button>
                ) : (
                  <Button type="primary" onClick={() => handleSubmit()} loading={updateIsLoading}>
                    Update
                  </Button>
                )}
              </>
            ) : (
              <Button type="primary" onClick={handleGetCredits}>
                Upgrade Plan
              </Button>
            )}
          </Space>
        </Col>
      </Row>
    </div>
  );
}

export default StepTitle;
